export default __webpack_public_path__ + "static/max_animate-a6dac08e9f8c37427b00fde72500abc6.gif";